// Mongolian (primary) & English translations for Gegee AI
export const dictionaries = {
  mn: {
    brand: "Gegee AI",
    nav: {
      features: "Боломжууд",
      pricing: "Үнэ",
      docs: "Баримт бичиг",
      login: "Нэвтрэх",
      signup: "Эхлэх",
      dashboard: "Хяналтын самбар",
      logout: "Гарах",
    },
    landing: {
      kicker: "АНХНЫ ӨӨРИЙН ХЭЛНИЙ AI IVR",
      hero_title_a: "Монгол хэлээр",
      hero_title_b: "ярьдаг таны бизнесийн AI телефон оператор",
      hero_sub: "Gegee AI нь танай бизнесийн дуудлагад 24/7, монгол хэлээр хариулж, мэдлэгийн сан дээр тулгуурлан үйлчлүүлэгчдийг үнэн зөв чиглүүлдэг олон-түрээслэгчтэй платформ юм.",
      cta_primary: "Үнэгүй туршаад үзэх",
      cta_secondary: "Демо үзэх",
      stats: {
        uptime: "Цагийн ажиллагаа",
        languages: "Хэл (MN/EN)",
        latency: "Дундаж хариулт",
      },
      features_title: "Юу хийж чадах вэ?",
      features_sub: "Бизнесүүдэд утасны үйлчилгээг автоматжуулах бүх хэрэгсэл",
      f_kb: { t: "Мэдлэгийн сан", d: "FAQ, баримт бичиг оруулж AI-гаа танай бизнест тохирмол болго." },
      f_voice: { t: "Жинхэнэ дуу хоолой", d: "Өөрийн STT/TTS моделоо холбож, монгол хэл дээрх дуу авиаг хянах." },
      f_escalation: { t: "Эскалацийн дүрэм", d: "Түлхүүр үг, цаг, мэдрэмж дээр үндэслэн хүний оператор руу шилжүүл." },
      f_analytics: { t: "Дуудлагын аналитик", d: "Бүх дуудлагын хураангуй, амжилт, эскалацийн харьцааг бодит цагт хянана." },
      f_multitenant: { t: "Олон-түрээслэгчтэй", d: "Нэг платформ дээр олон бизнес тус тусдаа найдвартай тусгаарлагдсан." },
      f_billing: { t: "SaaS төлбөр", d: "Хэрэглээний хэмжээгээр төлбөр; Starter, Growth, Enterprise багц." },
      pricing_title: "Энгийн, тунгалаг үнэ",
      pricing_sub: "Үнэ Монгол төгрөгөөр (₮)",
      plan_starter: "Starter",
      plan_growth: "Growth",
      plan_enterprise: "Enterprise",
      plan_popular: "Хамгийн алдартай",
      plan_cta: "Эхлэх",
      footer: "© 2026 Gegee AI. Монголын бизнесүүдэд зориулан зүрх сэтгэлээр бүтээв.",
    },
    auth: {
      login_title: "Эргэн тавтай морил",
      login_sub: "Та өөрийн Gegee AI хяналтын самбар руу нэвтэрнэ үү",
      signup_title: "Шинэ түрээслэгч үүсгэх",
      signup_sub: "Минут хүрэлгүй бүртгүүлээд AI оператороо эхлүүлээрэй",
      email: "Имэйл",
      password: "Нууц үг",
      name: "Нэр",
      company: "Компани/Бизнесийн нэр",
      submit_login: "Нэвтрэх",
      submit_signup: "Бүртгүүлэх",
      have_account: "Аль хэдийн бүртгэлтэй юу?",
      no_account: "Бүртгэл байхгүй юу?",
      go_login: "Нэвтрэх",
      go_signup: "Бүртгүүлэх",
      forgot_link: "Нууц үгээ мартсан уу?",
      forgot_title: "Нууц үг сэргээх",
      forgot_sub: "Та өөрийн имэйлийг бичнэ үү. Бид сэргээх линк илгээх болно.",
      forgot_submit: "Сэргээх линк илгээх",
      forgot_done: "Хэрэв энэ имэйл бүртгэлтэй бол сэргээх линк илгээгдсэн байна. (Demo: backend log дээр харагдана)",
      reset_title: "Шинэ нууц үг тохируулах",
      reset_sub: "Шинэ нууц үгээ бичээд баталгаажуулна уу",
      reset_new: "Шинэ нууц үг",
      reset_confirm: "Дахин бичих",
      reset_submit: "Хадгалах",
      reset_done: "Нууц үг солигдлоо! Нэвтрэх рүү шилжиж байна...",
      reset_min: "Нууц үг 6 тэмдэгтээс багагүй байна",
      reset_mismatch: "Нууц үгнүүд таарахгүй байна",
      reset_no_token: "Линк буруу. Нууц үг сэргээх хүсэлтээ дахин илгээнэ үү",
    },
    sidebar: {
      dashboard: "Самбар",
      kb: "Мэдлэгийн сан",
      rules: "Эскалацийн дүрэм",
      demo: "AI демо",
      call_demo: "AI Call DEMO",
      sip: "SIP Configure",
      calls: "Дуудлагын түүх",
      settings: "Тохиргоо",
      billing: "Төлбөр",
      admin: "Супер админ",
    },
    sip: {
      title: "SIP Configure",
      sub: "Twilio SIP болон SIP trunk тохиргоо (түрээслэгчээр)",
      twilio_section: "Twilio SIP",
      twilio_number: "Twilio phone number",
      twilio_sip_domain: "Twilio SIP domain",
      twilio_sip_username: "SIP username",
      twilio_sip_password: "SIP password",
      inbound_webhook: "Inbound voice webhook URL",
      inbound_help: "Twilio number дээр 'A CALL COMES IN' webhook болгон тохируулна (TwiML endpoint).",
      status_callback: "Status callback URL",
      recording_callback: "Recording status callback URL",
      sip_section: "Your SIP trunk / PBX",
      sip_enabled: "Enable SIP routing",
      sip_enabled_hint: "Асаавал дуудлагыг SIP URI руу чиглүүлэх боломжтой.",
      sip_uri: "SIP URI",
      sip_transport: "Transport",
      outbound_proxy: "Outbound proxy",
      from_user: "From user",
      auth_user: "Auth username",
      auth_pass: "Auth password",
      notes_title: "Notes",
      notes: "Одоогоор эдгээр талбарууд нь тохиргоо хадгалах зориулалттай. Twilio voice webhook / SIP routing логикийг дараагийн алхамд холбоно.",
    },
    dashboard: {
      title: "Самбар",
      sub: "Танай AI оператороор хийгдсэн дуудлагын тойм",
      total_calls: "Нийт дуудлага",
      avg_duration: "Дундаж урт",
      success_rate: "Амжилттай %",
      escalation_rate: "Эскалаци %",
      avg_confidence: "Дундаж итгэл",
      recent_calls: "Сүүлийн дуудлагууд",
      no_calls: "Одоохондоо дуудлага байхгүй",
      timeseries: "Дуудлагын чиг хандлага",
    },
    kb: {
      title: "Мэдлэгийн сан",
      sub: "Танай AI оператор асуултанд хариулахдаа эдгээр асуулт-хариултыг ашиглана",
      add: "+ Шинэ оруулга",
      question: "Асуулт",
      answer: "Хариулт",
      category: "Ангилал",
      save: "Хадгалах",
      cancel: "Цуцлах",
      delete: "Устгах",
      edit: "Засах",
      empty: "Одоохондоо мэдлэгийн сан хоосон байна",
    },
    rules: {
      title: "Эскалацийн дүрмүүд",
      sub: "Хэзээ, хэрхэн хүний оператор руу шилжүүлэхээ зааж өг",
      add: "+ Шинэ дүрэм",
      name: "Нэр",
      trigger: "Тригер",
      value: "Утга",
      action: "Үйлдэл",
      target: "Зорилт (утас/имэйл)",
      enabled: "Идэвхтэй",
      types: { keyword: "Түлхүүр үг", sentiment: "Сэтгэгдэл", after_hours: "Цагаас гадуур", max_turns: "Хэт урт яриа" },
      actions: { transfer_human: "Хүн рүү шилжүүлэх", send_sms: "SMS илгээх", voicemail: "Дуут зурвас", callback: "Эргэж залгах" },
      empty: "Одоохондоо дүрэм байхгүй",
    },
    demo: {
      title: "AI оператороор тууш ярилцаарай",
      sub: "Доорх чатаар таны AI оператортой яаж ярилцахыг туршиж үзээрэй (GPT-4o дээр суурилсан)",
      placeholder: "Та оператораас юу асуухыг хүсэж байна вэ?",
      send: "Илгээх",
      reset: "Шинээр эхлүүлэх",
      thinking: "Бодож байна",
      hint: "Жишээ: Та нар хэдэн цагт ажилладаг вэ?",
      lang: "Хэл",
    },
    call_demo: {
      title: "AI Call DEMO",
      sub: "Жинхэнэ дуудлага шиг симуляц — микрофоноор ярьж (STT), AI хариу (LLM), хүсвэл чангаар уншуул (TTS).",
      greeting: "Сайн байна уу. Би таны AI оператор байна. Юугаар туслах вэ?",
      status: "Төлөв",
      state_idle: "Бэлэн",
      state_ringing: "Дуудлага орж байна…",
      state_connected: "Холбогдсон",
      state_ended: "Дууссан",
      start: "Дуудлага эхлүүлэх",
      end: "Дуудлага таслах",
      reset: "Шинээр эхлүүлэх",
      tts: "Дуугаар унших",
      ptt: "Push-to-talk",
      hold_to_talk: "Дарж ярь",
      listening: "Сонсож байна…",
      ptt_hint: "Товчийг дарж ярь, тавихад илгээгдэнэ.",
      no_speech: "Дуу танигдсангүй. Дахин оролдоно уу.",
      hint: "Дуудлага эхлүүлээд микрофоноор асуултаа хэлээрэй.",
      footer: "Тайлбар: Энэ демо нь 16kHz WAV руу хөрвүүлж STT руу илгээдэг. Хөтөч микрофон зөвшөөрөл шаардлагатай.",
      tts_missing: "Энэ хөтөч дээр чангаар унших боломжгүй байна.",
    },
    calls: {
      title: "Дуудлагын түүх",
      sub: "Бүх дуудлагын бичлэг, хураангуй, итгэлийн оноо",
      caller: "Залгасан дугаар",
      duration: "Үргэлжлэл",
      status: "Төлөв",
      lang: "Хэл",
      time: "Цаг",
      summary: "Хураангуй",
      conf: "Итгэл",
      escalated: "Эскалац.",
      empty: "Одоохондоо дуудлага байхгүй",
    },
    settings: {
      title: "Тохиргоо",
      sub: "AI оператортой холбоотой бүх тохиргоо",
      persona: "Зан төлөв (системийн зааварт хэрэглэгдэнэ)",
      primary_lang: "Үндсэн хэл",
      fallback_lang: "Нөөц хэл",
      hours: "Ажлын цаг",
      tz: "Цагийн бүс",
      after_hours: "Цагаас гадуурх мессеж",
      greeting: "Угтах мессеж",
      stt_section: "STT (Speech-to-Text) — Өөрийн моделоо холбох",
      stt_url: "STT эндпойнт URL",
      stt_key: "STT API түлхүүр",
      stt_lang: "STT хэлний код",
      stt_hotwords: "STT түлхүүр үг (hotwords)",
      stt_hotwords_help: "Таслалаар тусгаарласан түлхүүр үгс. KenLM асаалттай үед танилт сайжруулна. Ж: пицца, пепперони",
      tts_section: "TTS (Text-to-Speech) — Өөрийн моделоо холбох",
      tts_provider: "TTS provider",
      tts_region: "Azure region",
      tts_url: "TTS эндпойнт URL",
      tts_key: "TTS API түлхүүр",
      tts_voice: "TTS дуу хоолойн ID",
      max_turns: "Хамгийн их яриа",
      save: "Хадгалах",
      saved: "Хадгаллаа",
    },
    billing: {
      title: "Багц & Төлбөр",
      sub: "Танай түрээслэгчийн идэвхтэй багц",
      current: "Одоогийн багц",
      upgrade: "Сайжруулах",
      starter_d: "Жижиг бизнесүүдэд",
      growth_d: "Өсөж буй компаниудад",
      enterprise_d: "Том байгууллагуудад",
      mock_note: "Жинхэнэ төлбөр Stripe-р тун удахгүй идэвхжих болно",
    },
    superadmin: {
      title: "Супер Админ",
      sub: "Бүх түрээслэгчийн жагсаалт ба хяналт",
      platform_title: "Платформ STT тохиргоо",
      platform_sub: "Бүх компаниудад үйлчлэх KenLM ба OpenAI correction асаалт",
      kenlm: "KenLM decode",
      kenlm_help: "Beam search + KenLM ашиглан үг хэллэгийг сайжруулна. Унтраавал greedy decode ашиглана.",
      openai_correct: "OpenAI correction",
      openai_help: "STT текстийг OpenAI-р засварлаж цэвэрлэх (нэмэлт зардал/сааталтай).",
      openai_model: "OpenAI model",
      openai_prompt: "Correction prompt",
      enabled: "ON",
      disabled: "OFF",
      save: "Хадгалах",
      saved: "Хадгаллаа",
      tenants: "Түрээслэгчид",
      total_calls: "Нийт дуудлага",
      total_users: "Нийт хэрэглэгч",
      active: "Идэвхтэй",
      suspended: "Түр зогссон",
      action_suspend: "Зогсоох",
      action_activate: "Идэвхжүүлэх",
      company: "Компани",
      plan: "Багц",
      status: "Төлөв",
      users: "Хэрэглэгч",
      calls: "Дуудлага",
      created: "Үүссэн",
    },
    common: {
      lang: "Хэл",
      close: "Хаах",
      try_again: "Дахин оролдох",
      loading: "Уншиж байна...",
      hello: "Сайн байна уу",
      yes: "Тийм",
      no: "Үгүй",
    },
  },
  en: {
    brand: "Gegee AI",
    nav: {
      features: "Features",
      pricing: "Pricing",
      docs: "Docs",
      login: "Log in",
      signup: "Get started",
      dashboard: "Dashboard",
      logout: "Log out",
    },
    landing: {
      kicker: "FIRST AI IVR BUILT NATIVELY FOR MONGOLIA",
      hero_title_a: "Your AI phone agent",
      hero_title_b: "that speaks Mongolian",
      hero_sub: "Gegee AI answers your business calls 24/7 in fluent Mongolian, grounded in your knowledge base, with seamless escalation to human agents — all from one multi-tenant platform.",
      cta_primary: "Start free trial",
      cta_secondary: "Watch demo",
      stats: { uptime: "Uptime", languages: "Languages (MN/EN)", latency: "Avg response" },
      features_title: "What it can do",
      features_sub: "Everything to automate phone support for your business",
      f_kb: { t: "Knowledge Base", d: "Upload FAQs and docs to ground the AI in your business reality." },
      f_voice: { t: "Bring-your-own voice", d: "Plug in your own STT/TTS models for native Mongolian voice." },
      f_escalation: { t: "Escalation rules", d: "Hand off to a human on keywords, sentiment, or after-hours." },
      f_analytics: { t: "Call analytics", d: "Real-time dashboards on calls, success rate, escalation rate." },
      f_multitenant: { t: "Multi-tenant", d: "Many businesses, isolated data, one secure platform." },
      f_billing: { t: "SaaS billing", d: "Tiered Starter, Growth, Enterprise plans with usage metering." },
      pricing_title: "Simple, transparent pricing",
      pricing_sub: "Prices in Mongolian Tugrik (₮)",
      plan_starter: "Starter",
      plan_growth: "Growth",
      plan_enterprise: "Enterprise",
      plan_popular: "Most popular",
      plan_cta: "Get started",
      footer: "© 2026 Gegee AI. Built with care for Mongolian businesses.",
    },
    auth: {
      login_title: "Welcome back",
      login_sub: "Sign in to your Gegee AI dashboard",
      signup_title: "Create a new tenant",
      signup_sub: "Sign up in under a minute and launch your AI agent",
      email: "Email",
      password: "Password",
      name: "Name",
      company: "Company / Business name",
      submit_login: "Log in",
      submit_signup: "Sign up",
      have_account: "Already have an account?",
      no_account: "No account yet?",
      go_login: "Log in",
      go_signup: "Sign up",
      forgot_link: "Forgot password?",
      forgot_title: "Reset your password",
      forgot_sub: "Enter your email and we'll send you a reset link.",
      forgot_submit: "Send reset link",
      forgot_done: "If that email is registered, a reset link has been sent. (Demo: link is logged to the backend console.)",
      reset_title: "Set a new password",
      reset_sub: "Type your new password and confirm it.",
      reset_new: "New password",
      reset_confirm: "Confirm password",
      reset_submit: "Save",
      reset_done: "Password updated! Redirecting to log in…",
      reset_min: "Password must be at least 6 characters",
      reset_mismatch: "Passwords don't match",
      reset_no_token: "Invalid link. Please request a new reset link.",
    },
    sidebar: {
      dashboard: "Dashboard",
      kb: "Knowledge Base",
      rules: "Escalation Rules",
      demo: "AI Demo",
      call_demo: "AI Call Demo",
      sip: "SIP Configure",
      calls: "Call History",
      settings: "Settings",
      billing: "Billing",
      admin: "Super Admin",
    },
    sip: {
      title: "SIP Configure",
      sub: "Tenant-managed Twilio SIP and SIP trunk settings",
      twilio_section: "Twilio SIP",
      twilio_number: "Twilio phone number",
      twilio_sip_domain: "Twilio SIP domain",
      twilio_sip_username: "SIP username",
      twilio_sip_password: "SIP password",
      inbound_webhook: "Inbound voice webhook URL",
      inbound_help: "Set this as the Twilio number 'A CALL COMES IN' webhook (TwiML endpoint).",
      status_callback: "Status callback URL",
      recording_callback: "Recording status callback URL",
      sip_section: "Your SIP trunk / PBX",
      sip_enabled: "Enable SIP routing",
      sip_enabled_hint: "When enabled, calls can be routed to the SIP URI.",
      sip_uri: "SIP URI",
      sip_transport: "Transport",
      outbound_proxy: "Outbound proxy",
      from_user: "From user",
      auth_user: "Auth username",
      auth_pass: "Auth password",
      notes_title: "Notes",
      notes: "These fields currently store configuration only. We’ll wire Twilio voice webhooks / SIP routing logic in the next step.",
    },
    dashboard: {
      title: "Dashboard",
      sub: "Overview of calls handled by your AI agent",
      total_calls: "Total calls",
      avg_duration: "Avg duration",
      success_rate: "Success rate",
      escalation_rate: "Escalation rate",
      avg_confidence: "Avg confidence",
      recent_calls: "Recent calls",
      no_calls: "No calls yet",
      timeseries: "Call trend",
    },
    kb: {
      title: "Knowledge Base",
      sub: "These Q&A pairs ground your AI agent's answers",
      add: "+ New entry",
      question: "Question",
      answer: "Answer",
      category: "Category",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      empty: "Knowledge base is empty",
    },
    rules: {
      title: "Escalation rules",
      sub: "Define when and how to hand off to a human",
      add: "+ New rule",
      name: "Name",
      trigger: "Trigger",
      value: "Value",
      action: "Action",
      target: "Target (phone/email)",
      enabled: "Enabled",
      types: { keyword: "Keyword", sentiment: "Sentiment", after_hours: "After hours", max_turns: "Max turns" },
      actions: { transfer_human: "Transfer to human", send_sms: "Send SMS", voicemail: "Voicemail", callback: "Callback" },
      empty: "No rules yet",
    },
    demo: {
      title: "Try your AI agent live",
      sub: "Chat with your configured AI agent (powered by GPT-4o)",
      placeholder: "Ask the agent anything…",
      send: "Send",
      reset: "Restart",
      thinking: "Thinking",
      hint: "Try: What are your business hours?",
      lang: "Language",
    },
    call_demo: {
      title: "AI Call Demo",
      sub: "A real call-style simulator — speak (STT), get an AI reply (LLM), optionally read aloud (TTS).",
      greeting: "Hello! I’m your AI phone agent. How can I help?",
      status: "Status",
      state_idle: "Ready",
      state_ringing: "Ringing…",
      state_connected: "Connected",
      state_ended: "Ended",
      start: "Start call",
      end: "End call",
      reset: "Reset",
      tts: "Read aloud",
      ptt: "Push-to-talk",
      hold_to_talk: "Hold to talk",
      listening: "Listening…",
      ptt_hint: "Hold the button to speak; release to send.",
      no_speech: "No speech detected. Try again.",
      hint: "Start the call, then speak your question into the mic.",
      footer: "Note: This demo converts mic audio to 16kHz WAV and sends it to STT. Browser microphone permission required.",
      tts_missing: "Read-aloud is not supported in this browser.",
    },
    calls: {
      title: "Call history",
      sub: "All calls, summaries, confidence scores",
      caller: "Caller",
      duration: "Duration",
      status: "Status",
      lang: "Lang",
      time: "Time",
      summary: "Summary",
      conf: "Conf.",
      escalated: "Esc.",
      empty: "No calls yet",
    },
    settings: {
      title: "Settings",
      sub: "All AI agent configuration",
      persona: "Persona (used in system prompt)",
      primary_lang: "Primary language",
      fallback_lang: "Fallback language",
      hours: "Business hours",
      tz: "Timezone",
      after_hours: "After-hours message",
      greeting: "Greeting message",
      stt_section: "STT (Speech-to-Text) — bring your own model",
      stt_url: "STT endpoint URL",
      stt_key: "STT API key",
      stt_lang: "STT language code",
      stt_hotwords: "STT hotwords (keywords)",
      stt_hotwords_help: "Comma-separated keywords to bias decoding (when KenLM is enabled). Example: pizza, pepperoni",
      tts_section: "TTS (Text-to-Speech) — bring your own model",
      tts_provider: "TTS provider",
      tts_region: "Azure region",
      tts_url: "TTS endpoint URL",
      tts_key: "TTS API key",
      tts_voice: "TTS voice ID",
      max_turns: "Max turns",
      save: "Save",
      saved: "Saved",
    },
    billing: {
      title: "Plans & Billing",
      sub: "Active plan for your tenant",
      current: "Current plan",
      upgrade: "Upgrade",
      starter_d: "For small businesses",
      growth_d: "For growing companies",
      enterprise_d: "For large organizations",
      mock_note: "Real billing via Stripe coming soon",
    },
    superadmin: {
      title: "Super Admin",
      sub: "All tenants and platform controls",
      platform_title: "Platform STT settings",
      platform_sub: "Global toggles for KenLM and OpenAI correction (applies to all tenants).",
      kenlm: "KenLM decode",
      kenlm_help: "Beam search decoding with KenLM. If off, uses greedy decoding.",
      openai_correct: "OpenAI correction",
      openai_help: "Post-process STT text with OpenAI (adds latency and cost).",
      openai_model: "OpenAI model",
      openai_prompt: "Correction prompt",
      enabled: "ON",
      disabled: "OFF",
      save: "Save",
      saved: "Saved",
      tenants: "Tenants",
      total_calls: "Total calls",
      total_users: "Total users",
      active: "Active",
      suspended: "Suspended",
      action_suspend: "Suspend",
      action_activate: "Activate",
      company: "Company",
      plan: "Plan",
      status: "Status",
      users: "Users",
      calls: "Calls",
      created: "Created",
    },
    common: {
      lang: "Language",
      close: "Close",
      try_again: "Try again",
      loading: "Loading...",
      hello: "Hello",
      yes: "Yes",
      no: "No",
    },
  },
};
